import { selectFeature } from "../ducks/features/selectors";
import { useSelector } from "react-redux";
import { FeatureName } from "dora-contracts";

const useFeature = (feature: FeatureName) => {
  return useSelector(selectFeature(feature));
};

export default useFeature;
